import { http } from '../../../api/http-common';

const list = async (params) => {
	try {
		const { data } = await http.get('tool', { params });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const updatePassword = async (payload) => {
	try {
		const { data } = await http.post('auth/password-update', payload);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const getResponsibles = async (params) => {
	try {
		const { data } = await http.get('user/find-responsibles', { params });
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

const findById = async (id) => {
	try {
		const { data } = await http.get(`user/${id}`);
		return data || null;
	} catch (error) {
		return Promise.reject(error);
	}
};

export { list, updatePassword, getResponsibles, findById };
